<template>
  <div class="users-education-list">
    <button class="users-education-list__title" @click="redirectToBack">
      <svg-icon name="arrow-left" />
      <span>День 2. ЗВУК</span>
    </button>
    <el-row :gutter="16" type="flex" class="flex-wrap">
      <el-col>
        <h1 class="users-education-list__subtitle"><svg-icon name="timer" /> 22 часа 43 минуты</h1>
      </el-col>
      <el-col
        v-for="item in items"
        :key="item.id"
        class="users-education-list__card"
        :xl="6"
        :lg="8"
        :sm="12"
      >
        <DaysCard :item="item" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import DaysCard from '@/components/Users/Education/DaysCard'

export default {
  name: 'EducationList',
  components: { DaysCard },
  data: () => ({
    items: [
      {
        id: 1,
        number: 1,
        content: 'М, П, Б, Н, Т, Д, К, Г, Х, Р ',
        points: 80,
        type: 'letters',
        status: 2
      },
      {
        id: 2,
        number: 2,
        content: 'М, П, Б, Н, Т, Д, К, Г, Х, Р',
        points: 80,
        type: 'test',
        status: 1
      },
      {
        id: 3,
        number: 3,
        content: 'А, О, У, Э, И',
        points: 100,
        type: 'content',
        status: 0
      },
      {
        id: 4,
        number: 4,
        content: 'А, О, У, Э, И',
        points: 100,
        type: 'material',
        status: 0
      },
      {
        id: 5,
        number: 5,
        content: 'А, О, У, Э, И',
        points: 100,
        type: 'material',
        status: 0
      },
      {
        id: 6,
        number: 6,
        content: 'А, О, У, Э, И',
        points: 100,
        type: 'material',
        status: 0
      }
    ]
  }),

  methods: {
    redirectToBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.users-education-list {
  &__title {
    display: flex;
    align-items: center;
    margin-bottom: 52px;
    transition: 0.3s;

    @include md-and-down {
      margin-bottom: 28px;
    }

    svg {
      stroke: $luchmara;
      width: 20px;
      margin-right: 22px;
    }

    span {
      font-weight: bold;
      font-size: 24px;
      letter-spacing: 0.35px;
      color: $luchmara;

      @include md-and-down {
        font-size: 20px;
      }
    }

    &:hover {
      opacity: 0.8;
    }
  }

  &__subtitle {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 18px;
    letter-spacing: 0.2px;
    color: $luchmara;

    @include md-and-down {
      font-size: 20px;
    }

    svg {
      width: 32px;
      height: 32px;
      margin-right: 8px;
      fill: $luchmara;

      @include md-and-down {
        margin-right: 12px;
        width: 24px;
        height: 24px;
      }
    }
  }

  &__card {
    margin-top: 16px;
  }
}
</style>
